import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { CrudService } from '../../../crud/crud.service';
import { environment } from '../../../../environments/environment';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import * as moment from 'moment';

@Component({
  selector: 'app-caja-lista',
  templateUrl: './lista.component.html'
})

export class ListaComponent implements OnInit{
  tamano = document.body.clientHeight;;

  configuracion = JSON.parse(localStorage.getItem('configuracion'));
  permisos = JSON.parse(localStorage.getItem('permisos'));

  pdf_cargando = false;
  xml_cargando = false;
  cancelar_cargando = false;
  enviar_cargando = false;
  borrarCargando = false;
  contador;

  cargando = false;
  error_cancelar = false;
  sin_resultado = '';
  errores = [];

  VERSION_CFDI = environment.VERSION_CFDI;
  CFDI_PATH = environment.CFDI_PATH;

  facturacion = {
    Complemento: ''
  };
  xml_generado;

  factura_json;
  factura_uuid;
  factura_index;
  color = [];
  borrado_exitoso = false;

  constructor(
    private crudService: CrudService,
    private route: ActivatedRoute,
    private _sanitizer: DomSanitizer) { }

  ngOnInit() {
    document.getElementById("catalogos").click();
  }
  // abrir modal para confirmar cancelar
  ventana_cancelar(factura_json, factura_uuid, factura_index) {
    this.factura_json = factura_json;
    this.factura_uuid = factura_uuid;
    this.factura_index = factura_index;

    document.getElementById('confirmarCancelar').classList.add('is-active');
  }
  // iniciar el proceso de cancelacion
  cancelar(factura_json, factura_uuid, i) {

    this.cargando = true;
    this.borrarCargando = true;
    this.error_cancelar = false;
    this.borrado_exitoso = false;
    let id = factura_uuid + '@' + this.configuracion.sucursal.facturacion.rfc;
    this.crudService.eliminar(id, this.CFDI_PATH + '/api/v1/facturar').subscribe(
      resultado => {
        this.cargando = false;
        if (resultado.status === 200) {
          // datos de respuesta del pac
          let respuesta = resultado.data;
          // guardar la factura local para consultas posteriores
          this.guardar_acuse(factura_json, respuesta, i);
        } else {
          if (Array.isArray(resultado.messages)) {
            this.errores = resultado.messages;
            setTimeout(() => {
              this.errores = [];
            }, 3500 * this.errores.length);
          } else {
            this.sin_resultado = resultado.messages;
            setTimeout(() => {
              this.sin_resultado = '';
            }, 3000);
          }
        }
        this.borrarCargando = false;
      },
      error => {
        this.borrarCargando = false;
        this.cargando = false;
        this.error_cancelar = true;
        setTimeout(() => {
          this.error_cancelar = false;
        }, 3500);
      }
    );
  }
  guardar_acuse(factura_json, respuesta, i) {
    this.crudService.editar(factura_json.id, respuesta.cancelResult, 'factura').subscribe(
      resul => {
        document.getElementById('confirmarCancelar').classList.remove('is-active');

        this.borrado_exitoso = true;
        factura_json.estado = 4;
        this.color[i] = true;
        setTimeout(() => {
          this.color[i] = false;
          this.borrado_exitoso = false;
        }, 3500);

      },
      erro => {
      }
    );
  }
  personas_rfcs_seleccionado = {};
  // abrir modal para mostrar el pdf
  pdf(item) {
    console.log(item);
    this.personas_rfcs_seleccionado = item.personas_rfcs_seleccionado;
    this.facturacion = item.json;
    document.getElementById('verPdf').classList.add('is-active');
  }

  // abrir modal para mostrar el xml
  xml(item, index) {
    let nombre: String = item.uuid;
    let fileToExport;
    if (item.estado == 4)
      fileToExport = new Blob([item.acuse_cancelacion], { type: 'text/xml' });
    else
      fileToExport = new Blob([item.xml], { type: 'text/xml' });

    let a = document.createElement('a');
    a.href = URL.createObjectURL(fileToExport);
    a.target = '_blank';
    a.download = nombre + '.xml';
    a.click();
  }

  // iniciar el proceso de enviar por correo
  SelloCFD = [];
  SelloSAT = [];
  CadenaOriginal = [];
  enviar(item, index) {
    this.contador = index;
    let CFD = item.json.Complemento.TimbreFiscalDigital.SelloCFD;
    this.SelloCFD[0] = CFD.substr(0, 234);
    this.SelloCFD[1] = CFD.substr(234, CFD.length);

    let SAT = item.json.Complemento.TimbreFiscalDigital.SelloSAT;
    this.SelloSAT[0] = SAT.substr(0, 234);
    this.SelloSAT[1] = SAT.substr(234, CFD.length);

    let CAO = item.json.Complemento.TimbreFiscalDigital.CadenaOriginal;
    this.CadenaOriginal[0] = CAO.substr(0, 234);
    this.CadenaOriginal[1] = CAO.substr(234, CFD.length);


    this.facturacion = item.json;

    this.cargando = true;
    setTimeout(() => {
      let html = document.getElementById('enviar_pdf').innerHTML;
      html = encodeURIComponent(html);

      let json: any = {
        enviar_factura: true,
        html: html,
        data: item
      };

      this.crudService.crear(json, 'factura').subscribe(
        resultado => {
          this.cargando = false;
          this.sin_resultado = resultado.messages;
          setTimeout(() => {
            this.sin_resultado = '';
          }, 3500);
          this.cargando = false;
        },
        error => {
          this.cargando = false;
        }
      );
    }, 500);
  }

  logo;
  logo_sucursal;
  logo_empresa;
  asignarLogos(logos) {
    if (logos) {
      this.logo_sucursal = logos;
      this.logo_empresa = logos;
      this.logo = logos;
    }
  }
}
